import React, { useContext, useEffect, useState } from 'react';
import Box from '../../components/single_component/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ProjectDetails from '../componets/ProjectDetails';
import theme from '../../utils/Theme';
import TransactionsContex from '../../context/TransactionsContex';
import ProjectContext from '../../context/ProjectContext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import TransactionTables from '../componets/TransactionTables';
import Button from '../../components/single_component/Button';
import Text from '../../components/single_component/Text';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function ViewProjectContainer() {
  const [selectedTab, setSelectedTab] = React.useState(0);

  const { getTransaction, Transaction } = useContext(TransactionsContex);

  const { getProject, ProjectData, documents } = useContext(ProjectContext);

  const { id } = useParams();
  const [Page, setPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [Next, setNext] = useState();
  const [Previous, setPrevious] = useState();
  const [currPage, setcurrPage] = useState(1);

  useEffect(() => {
    setPage(Transaction?.totalPages);
    setNext(Transaction?.nextPage);
    setPrevious(Transaction?.prevPage);
  }, [Transaction]);

  useEffect(() => {
    getTransaction(Page, rowsPerPage, {
      filter: {
        projectId: id,
      },
    });
    getProject(id);
  }, [currPage, rowsPerPage]);

  const handleTabChange = (event: any, newValue: number) => {
    setSelectedTab(newValue);
  };

  const location = useLocation();
  const navigate = useNavigate();
  const groupName = location.state?.groupName ?? 'N/A';

  // const handleBack = () => {
  //   const { groupId, spvId, spvName, groupName: gName } = location.state ?? {};
  //   navigate(`/developer-group/${groupId}/view-spv/${spvId}`, {
  //     state: {
  //       spvId,
  //       spvName,
  //       groupName: gName,
  //       groupId,
  //     },
  //   });
  // };

  return (
    <Box>
      <Box style={{ width: '85%', margin: 'auto', marginBottom: '12px' }}>
        <Button
          extra={{ variant: 'outlined' }}
          icons={<ArrowBackIcon fontSize="small" />}
          onClick={()=>navigate(-1)}
          style={{
            borderRadius: '20px',
            padding: '4px 16px',
            color: '#104960',
            borderColor: '#104960',
            textTransform: 'none',
          }}>
          <Text style={{ fontSize: 13, color: '#104960' }}>Back</Text>
        </Button>
      </Box>
      <Box
        style={{
          width: '85%',
          margin: 'auto',
          boxShadow: ' 0px 2px 10px 0px #1049601A',
          borderRadius: 2,
        }}>
        <Box style={{ background: 'white', borderRadius: 2 }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          centered
          sx={{
            backgroundColor: '#E5F7FF',
            // paddingInline: 5,
            '& .MuiTabs-flexContainer': { justifyContent: 'flex-start' },
            '& .MuiTabs-indicator': { background: '#25A9E0', height: 3 },
          }}>
          <Tab
            label="Project Details"
            sx={{
              fontSize: 13,
              fontWeight: 600,
              color: theme.palette.primary.main,
              padding: '12px 80px',
            }}
          />
          <Tab
            label="Transactions Details"
            sx={{
              fontSize: 13,
              fontWeight: 600,
              color: theme.palette.primary.main,
              padding: '12px 80px',
            }}
          />
        </Tabs>

        {selectedTab === 0 && (
          <ProjectDetails
            extra={{
              ProjectData: ProjectData ?? {},
              documents,
              projectId: id,
              groupName,
            }}
          />
        )}
        {selectedTab === 1 && (
          <TransactionTables
            extra={{
              data: Transaction.records ?? [],
              page: 'Project',
              Page,
              setPage,
              rowsPerPage,
              setrowsPerPage,
              Next,
              setNext,
              Previous,
              setPrevious,
              currPage,
              setcurrPage,
            }}
          />
        )}
      </Box>
      </Box>
    </Box>
  );
}

export default ViewProjectContainer;
